module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// /home/travis/build/Pedro-vk/Bet-Token-wallet/node_modules/readable-stream/writable-browser.js
// module id = QRYi
// module chunks = 0